import './selectSingle.scss'
import { useState, useEffect } from 'react'
import { Autocomplete, Box, TextField, Typography } from '@mui/material'
import { mapCodesToNames } from '../../../../utilities/MapCodesToNames'
import { useTranslation } from 'react-i18next'
import { toCamelCase } from '../../../../utilities/formatters/camelCase'

const SelectSingle = ({ propertie, ruleParameters, setRuleParameters, posibleValues, desc, isEditing, schema, translateValues }) => {
  const [selected, setSelected] = useState(null)
  const { t } = useTranslation(['common', 'rules'])

  // Function to get translated label for time granularities
  const getTranslatedLabel = (option) => {
    if (translateValues) {
      const translated = t(`common:${option}`, { defaultValue: option })
      return translated
    }
    return mapCodesToNames(option)
  }

  useEffect(() => {
    const currentValue = ruleParameters[propertie]

    if (currentValue !== undefined && currentValue !== selected) {
      setSelected(currentValue)
    }

    if (currentValue === undefined) {
      setSelected(null)
    }
  }, [propertie, ruleParameters])

  const handleChange = (event, value) => {
    setSelected(value)
    
    if (value === null || value === undefined || value === '') {
      const updatedParameters = { ...ruleParameters }
      delete updatedParameters[propertie]
      setRuleParameters(updatedParameters)
      return
    }
    const updatedParameters = { ...ruleParameters, [propertie]: value }
    setRuleParameters(updatedParameters)
  }

  return (
    <Box className="select-single-container">
      {desc && <Typography variant="subtitle4">{t(`rules:${toCamelCase(desc)}`)}</Typography>}

      <Autocomplete
        options={posibleValues}
        getOptionLabel={(option) => getTranslatedLabel(option)}
        filterSelectedOptions
        value={selected}
        disabled={!isEditing}
        onChange={(e, value) => handleChange(e, value)}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            placeholder={`${t('common:select')} ${t('common:or')} ${t('common:search')}...`}
          />
        )}
      />
    </Box>
  )
}

export default SelectSingle
